import React, { useState, useMemo, Fragment } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import Checkbox from 'components/elements/atoms/Checkbox';
import { Icon, ICONS } from 'components/Icons';
import classNames from 'classnames';

import './TableColumnFilter.scss';

export default function TableColumnFilter({
  options,
  onChange,
  value,
  single = true,
  showAll = false,
  allLabel = 'All',
  allowSearch = false,
  filterElm,
}) {
  const [search, setSearch] = useState('');

  const filteredOptions = useMemo(() => {
    if (!search.trim().length) {
      return options;
    }

    return options.filter(
      (i) => i.label.toLowerCase().indexOf(search.toLowerCase()) !== -1,
    );
  }, [options, search]);

  const renderSearch = () => {
    if (!allowSearch) {
      return null;
    }

    return (
      <input
        type="text"
        className="form-control input-search"
        placeholder="search"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
    );
  };

  const renderFilter = () => {
    if (filterElm) {
      return filterElm;
    }

    return (
      <Fragment>
        {renderSearch()}
        <div className="options-container">
          {showAll && (
            <Checkbox
              checked={single ? value === 'all' : value.includes('all')}
              handleChange={(e) => {
                if (single) {
                  onChange('all');
                } else {
                  onChange(['all']);
                }
              }}
            >
              {allLabel}
            </Checkbox>
          )}
          {/* {filteredOptions.map((i) => (
            <Checkbox
              key={i.label}
              checked={
                single ? value === i.value : value.indexOf(i.value) !== -1
              }
              handleChange={(e) => {
                if (single) {
                  onChange(i.value);
                } else {
                  let newValue = [...value];

                  if (showAll && !single) {
                    newValue = newValue.filter((i) => i !== 'all');
                  }

                  if (e.target.checked) {
                    newValue = [...newValue, i.value];
                  } else {
                    const index = newValue.indexOf(i.value);
                    newValue = [
                      ...newValue.slice(0, index),
                      ...newValue.slice(index + 1),
                    ];
                  }

                  if (!newValue.length && showAll) {
                    newValue = ['all'];
                  }

                  onChange(newValue);
                }
              }}
            >
              {i.label}
            </Checkbox>
          ))} */}
          <TableColumnFilterOptions
            options={filteredOptions}
            single={single}
            value={value}
            onChange={onChange}
            showAll={showAll}
          />
        </div>
      </Fragment>
    );
  };

  return (
    <div
      className="d-inline-flex ml-2 flex-shrink-0 table-column-filter"
      onClick={(e) => e.stopPropagation()}
    >
      <OverlayTrigger
        trigger="click"
        rootClose
        placement="bottom"
        overlay={
          <Popover
            className="popover-table-column-filter"
            id="popover-table-column-filter"
          >
            {renderFilter()}
          </Popover>
        }
      >
        <Icon
          icon={ICONS.FILTER}
          className={classNames('av-blue cursor-pointer', {
            'av-orange': single
              ? showAll
                ? value !== 'all'
                : !!value
              : showAll
              ? !value.includes('all')
              : value.length,
          })}
        />
      </OverlayTrigger>
    </div>
  );
}

export function TableColumnFilterOptions({
  options,
  single = true,
  value,
  onChange,
  showAll = false,
}) {
  return options.map((i) => (
    <Checkbox
      key={i.label}
      checked={single ? value === i.value : value.indexOf(i.value) !== -1}
      handleChange={(e) => {
        if (single) {
          onChange(i.value);
        } else {
          let newValue = [...value];

          if (showAll && !single) {
            newValue = newValue.filter((i) => i !== 'all');
          }

          if (e.target.checked) {
            newValue = [...newValue, i.value];
          } else {
            const index = newValue.indexOf(i.value);
            newValue = [
              ...newValue.slice(0, index),
              ...newValue.slice(index + 1),
            ];
          }

          if (!newValue.length && showAll) {
            newValue = ['all'];
          }

          onChange(newValue);
        }
      }}
    >
      {i.label}
    </Checkbox>
  ));
}
